import WixExperiments, { ExperimentsProps } from '@wix/wix-experiments';

export const DEFAULT_EXPERIMENT_VALUE: Experiments = {
  'specs.funnel.MoveEnterpriseLinkToTopMenu': 'false',
};

export type Experiments = {
  'specs.funnel.MoveEnterpriseLinkToTopMenu': 'true' | 'false';
};

export const loadExperiments = async (): Promise<Experiments> => {
  try {
    const wixExperimentsOpts = getWixExperimentsOptions();
    const experiments = new WixExperiments(wixExperimentsOpts);
    await experiments.load('headerAndFooter');
    return Object.assign(DEFAULT_EXPERIMENT_VALUE, experiments.all());
  } catch (e) {
    console.error('Error to load experiments in Wix Header Footer');
    return DEFAULT_EXPERIMENT_VALUE;
  }
};

function getWixExperimentsOptions(): ExperimentsProps {
  const origin = window.location.origin;
  return origin === 'https://status.wix.com' ? { baseUrl: 'https://manage.wix.com' } : { useNewApi: window.WIX_HF_DEBUG };
}
